import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

const STORAGE_KEY = 'gastify_pwa_dismissed';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === '1') return;
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 sm:bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm bg-slate-900 text-white rounded-2xl shadow-2xl p-4 z-[80] flex items-start gap-3 animate-fade-up"
      data-testid="pwa-install-prompt">
      <div className="w-10 h-10 rounded-xl bg-emerald-400/20 flex items-center justify-center flex-shrink-0">
        <Download size={18} className="text-emerald-300" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold mb-0.5">Instalar Gastify no seu celular</p>
        <p className="text-xs text-slate-300 mb-3">Acesso direto pela tela inicial, sem abrir o navegador.</p>
        <div className="flex gap-2">
          <button onClick={install} data-testid="pwa-install-btn"
            className="px-3 py-1.5 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold rounded-lg transition-colors">
            Instalar
          </button>
          <button onClick={dismiss} data-testid="pwa-dismiss-btn"
            className="px-3 py-1.5 text-slate-300 hover:text-white text-xs rounded-lg transition-colors">
            Agora não
          </button>
        </div>
      </div>
      <button onClick={dismiss} className="text-slate-400 hover:text-white">
        <X size={16} />
      </button>
    </div>
  );
}
